export default "__VITE_ASSET__CBGnQ8QW__"